import { Navigate, Route, Routes } from "react-router-dom";
import { PortalLayout } from "./components/PortalLayout";
import { EventDetail } from "./routes/EventDetail";
import { EventsHome } from "./routes/EventsHome";
import { Invite } from "./routes/Invite";
import { SignIn } from "./routes/SignIn";

export function App() {
  return (
    <Routes>
      <Route path="/invite/:code" element={<Invite />} />
      <Route path="/sign-in" element={<SignIn />} />
      <Route element={<PortalLayout />}>
        <Route path="/" element={<EventsHome />} />
        <Route path="/events/:eventId" element={<EventDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
